import { render, staticRenderFns } from "./IotDevicePortDeleteDialog.vue?vue&type=template&id=73871f4f&scoped=true"
import script from "./IotDevicePortDeleteDialog.vue?vue&type=script&lang=ts"
export * from "./IotDevicePortDeleteDialog.vue?vue&type=script&lang=ts"
import style0 from "./IotDevicePortDeleteDialog.vue?vue&type=style&index=0&id=73871f4f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73871f4f",
  null
  
)

export default component.exports